import { useEffect, useState } from 'react';

const breakpoints = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

export default function useScreenBreakpoint() {
  const [breakpoint, setBreakpoint] = useState('xs');

  const getScreenBreakpoint = (): string => {
    const screen = getWindowDimensions();

    const keys = Object.keys(breakpoints);
    let foundedBreakpoint = 'xs';

    for (let i = 1; i < keys.length; i++) {
      if (screen.width >= breakpoints[keys[i]]) {
        foundedBreakpoint = keys[i];
      }
    }

    return foundedBreakpoint;
  };

  useEffect(() => {
    function handleResize() {
      const screenBreakpoint = getScreenBreakpoint();
      setBreakpoint(screenBreakpoint);
    }

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoint;
}
